// extracted by css-extract-rspack-plugin
export default {"TabList":"soiQ9"};